<!-- =========================================================================================
    File Name: MailItem.vue
    Description: Mail Item - Displays mail item
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div>
		<div class="sm:px-4 px-2 py-6" :class="{'mail__opened-mail': !message.seen}" v-if="!show">
			<!-- MAIL ROW 1 : META -->
			<div class="flex w-full" @click="showMessage">
				<feather-icon
					icon="MessageSquareIcon"
					class="bg-white mr-2 rounded-full g-label--normal"
					svgClasses="w-16 h-16"
				></feather-icon>
				<div class="flex w-full justify-between items-start">
					<div class="mail__details">
						<h5 class="mb-1 g-table--title" :class="{'font-semibold': !message.seen}">
							{{ stateMessage(message.state) }}
						</h5>
						<span v-if="message.user_name" class="vs-table-text" v-text="message.message_received"></span>
						<span v-else>(no subject)</span>
					</div>
					<div class="mail-item__meta flex items-center">
						<div class="email__labels hidden sm:flex items-center">
							<div class="h-2 w-2 rounded-full mr-2" :class="'bg-success'"></div>
						</div>
						<span class="g-table--title">{{ messageDate | date }}</span>
					</div>
				</div>
			</div>
			<!-- /MAIL ROW 1 -->
			<!-- MAIL ROW 2 : MSG & ACTIONS -->
			<div class="flex w-full">
				<div class="flex items-center ml-1">
					<vs-checkbox
						v-model="isSelectedMail"
						@click.stop
						class="vs-checkbox-medium ml-0 mr-1"
					></vs-checkbox>
					<feather-icon
						:icon="!message.seen ? 'EyeOffIcon' : 'EyeIcon'"
						class="cursor-pointer"
						:svgClasses="[
							{'text-secondary  stroke-current': message.seen},
							{'text-warning  stroke-current': !message.seen},
							'w-5',
							'h-5',
						]"
						@click.stop="toggleIsStarred"
					></feather-icon>
				</div>
				<div class="ml-5">
					<span class="g-label">{{ message.managed_response }}</span>
				</div>
			</div>
			<!-- /MAIL ROW 2 -->
		</div>
		<!-- <button v-on:click="show = !show">Toggle</button> -->
		<transition name="slide-fade">
			<vx-card v-if="show">
				<div class="my-6">
					<h5 class="mb-2 g-table--title">{{ stateMessage(message.state) }}</h5>
					<p class="text-grey vs-table-text">{{ message.message_received }}</p>
				</div>
				<vs-divider></vs-divider>
				<div class="flex flex-wrap justify-end">
					<vs-textarea :label="$t('Communication.MessageReply')" v-model="msg" class="g-label" />
					<vs-button type="border" color="warning" class="mt-3" @click="show = false"
						>{{ $t("Cancel") }}
					</vs-button>
					<vs-button
						type="border"
						color="primary"
						class="ml-3 mt-3"
						icon-pack="feather"
						icon="icon-send"
						@click="updateMessaje"
						>{{ $t("Submit") }}
					</vs-button>
				</div>
			</vx-card>
		</transition>
	</div>
</template>

<script>
import DateUtils from "@/helpers/DateUtils.js";
import Message from "@/models/Message.js";
import {updateFirebaseMessage} from "@/helpers/firebaseDB.js";

export default {
	props: {
		message: {
			type: Object,
			required: true,
		},
		isSelected: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			show: false,
			permissionsRequired: false,
			msg: "",
			is_selected_local: this.isSelected,
		};
	},
	computed: {
		communicationCreatePermission() {
			return this.$store.getters.checkPermission("COMMUNICATION_C");
		},
		communicationUpdatePermission() {
			return this.$store.getters.checkPermission("COMMUNICATION_U");
		},
		labelColor() {
			return (label) => {
				const tags = this.$store.state.emessage.mailTags;
				return tags.find((tag) => {
					return tag.value === label;
				}).color;
			};
		},
		relativeTime() {
			// 'Tue, 18 Mar 2025 19:35:52 GMT'
			const newDate = new Date(this.message.date);
			return DateUtils.relativeTime(newDate);
		},
		messageDate() {
			// 'Tue, 18 Mar 2025 19:35:52 GMT'
			return DateUtils.stringToDate(this.message.date);
		},
		isSelectedMail: {
			get() {
				return this.is_selected_local;
			},
			set(val) {
				this.is_selected_local = val;
			},
		},
		stateMessage() {
			return function (state) {
				if (state === "Resuelto") {
					return this.$t("Communication.Resolved");
				} else {
					return this.$t("Communication.PendingForResolved");
				}
			};
		},
	},
	methods: {
		openAlertPermission() {
			this.$vs.dialog({
				color: "danger",
				title: `${this.$t("Roles.Permissions.RequiredPermissionsText")} ${this.$t("Crud.Update")}`,
				text: this.$t("Roles.Permissions.NotPermissionsText"),
				acceptText: this.$t("Accept"),
			});
		},
		showMessage() {
			if (this.communicationUpdatePermission) {
				this.show = !this.show;
				this.message.selected = this.show;
			} else {
				this.openAlertPermission();
			}
		},
		toggleIsStarred() {
			const payload = {mailId: this.message.id, value: !this.message.seen};
		},
		updateMessaje() {
			let updatedMessage = new Message(this.message);
			updatedMessage.managed_response = this.msg;
			updatedMessage.seen = true;
			updateFirebaseMessage(updatedMessage)
				.then((res) => {
					this.show = false;
				})
				.catch((err) => console.error(err));
		},
		updateSeenMessage(val) {
			let updatedMessage = new Message(this.message);
			updatedMessage.seen = val;
			updateFirebaseMessage(updatedMessage);
		},
	},
	watch: {
		is_selected_local(val) {
			val ? this.$emit("addToSelected", this.message.key) : this.$emit("removeSelected", this.message.key);
		},
		isSelected(val) {
			this.is_selected_local = val;
		},
		show(val) {
			if (val) {
				this.msg = this.message.managed_response;
				this.updateSeenMessage(true);
			} else {
				this.msg = "";
				this.$emit("removeSelected", this.message.key);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all 0.3s ease;
}

.slide-fade-leave-active {
	transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(200px);
	opacity: 0;
}
</style>
